import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#162988', // A
          'primary-darken1': '#1d2861', // R
          'primary-lighten1': '#CED6FE', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#FF9F5A', // B
          'secondary-darken1': '#A80814', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#162988', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#162988', // H
          topSecondaryBtn: '#DE0E1E', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#162988', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#162988', // N
          secondaryOutLineBtnText: '#DE0E1E', // O
          topBtnUpTextSp: '#162988', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#162988',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#162988',
          accent: '#162988', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
